// extracted by mini-css-extract-plugin
export default {"appWidth":"800px","WheelContainer":"MonitoringWheel_WheelContainer__BZT-W","Pie":"MonitoringWheel_Pie__SzT+T"};